import _extends from "@babel/runtime/helpers/esm/extends";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Series from '../Series';

var BarSeries =
/*#__PURE__*/
function (_Component) {
  _inherits(BarSeries, _Component);

  function BarSeries() {
    _classCallCheck(this, BarSeries);

    return _possibleConstructorReturn(this, _getPrototypeOf(BarSeries).apply(this, arguments));
  }

  _createClass(BarSeries, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var chart = this.props.getChart();
      chart.update({
        chart: {
          inverted: true
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(Series, _extends({}, this.props, {
        type: "bar"
      }));
    }
  }]);

  return BarSeries;
}(Component);

export default BarSeries;